import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873m-3.4 11.006L9.25 22.12m-1.506-6.485L4 22.12m14.326-6.627L14.5 22.12"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873m-3.4 11.006L9.25 22.12m-1.506-6.485L4 22.12m14.326-6.627L14.5 22.12"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a9 9 0 10-9-9m-12-7.5c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754m-6.8 22.012L18.5 44.24m-3.012-12.97L8 44.24m28.652-13.254L29 44.24"
  }))
};
export var WeatherRain = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});